import { defineNuxtPlugin } from "nuxt/app"

export default defineNuxtPlugin(() => {

  const options = {
    displaylogo: false,
    displayModeBar: false,
    responsive: true
  }

  const graph = {
    graph_back_color: 'rgb(244, 244, 244)',
    font_family: 'Assistant',

    createTreeMap(labels, values, cardSize, color, title) {
      const parent = ['']

      Object.keys(labels).forEach(() => {
        parent.push('')
      })

      return {
        data: [
          {
            labels,
            values,
            parents: parent,
            type: 'treemap',
            textinfo: 'label+value+percent',
            marker: {
              colors: color
            }
          }
        ],
        layout: {
          autosize: true,
          font: {
            family: this.font_family
          },
          yaxis: { fixedrange: true },
          xaxis: { fixedrange: true },
          paper_bgcolor: this.graph_back_color,
          plot_bgcolor: this.graph_back_color,
          margin: { r: 5, t: 5, l: 5, b: 5 }
        },
        config: options,
        size: cardSize,
        title
      }
    },

    createPieChart(labels, values, cardSize, color, label, title, hole = 0) {
      return {
        data: [
          {
            labels,
            values,
            type: 'pie',
            hole,
            marker: {
              colors: color
            }
          }
        ],
        layout: {
          autosize: true,
          font: {
            family: this.font_family
          },
          yaxis: { fixedrange: true },
          xaxis: { fixedrange: true },
          paper_bgcolor: this.graph_back_color,
          plot_bgcolor: this.graph_back_color,
          margin: { r: 0, t: 0, l: 0, b: 0 },
          legend: {
            x: 0.5,
            y: -0.2,
            xanchor: 'center',
            orientation: 'h'
          }
        },
        config: options,
        size: cardSize,
        title
      }
    }
  }

  return {
    provide: {
      graph
    }
  }
})
